import { CurrencyBN } from './currencyBN.js';
const MINOR_UNITS = 2;
const parse = (value) => typeof value === 'string' ? value.replace(/[^0-9.-]+/g, '') : value;
/**
 * @param value A major unit value (5.99)
 * @returns Currency in a minor unit amount (e.g. 5.99 -> 599, dollars to cents)
 */
export const toMinorUnit = (value) => new CurrencyBN(!value ? 0 : value)
    .decimalPlaces(MINOR_UNITS)
    .times(Math.pow(10, MINOR_UNITS))
    .toNumber();
/**
 * @param value A minor-unit value
 * @returns Currency in a major unit amount (e.g. 599 -> 5.99, cents to dollars)
 */
export const toMajorUnit = (value) => new CurrencyBN(!value ? 0 : value)
    .dividedBy(Math.pow(10, MINOR_UNITS))
    .toNumber();
/**
 * @param value A major unit string
 * @returns Currency as a major unit number (e.g. dollars).
 */
export const parseToMajorUnit = (value) => new CurrencyBN(Number(parse(value))).toNumber();
/**
 * @param value A major unit string
 * @returns Currency as a minor unit number (e.g. cents)
 */
export const parseToMinorUnit = (value) => toMinorUnit(Number(parse(value)));
//# sourceMappingURL=conversions.js.map